module.exports = __webpack_public_path__ + "img/leave.6a625754.svg";